import { Tooltip } from 'antd'

const ELLIPSIS = '...'
const TAIL_LENGTH = 8

export const truncatePath = (path: string, length = 30): string => {
  if (!path) return
  if (path.length <= length) return path

  if (length <= TAIL_LENGTH + ELLIPSIS.length) {
    return path
  }

  const first = path.slice(0, length - TAIL_LENGTH - ELLIPSIS.length)
  const last = path.slice(-TAIL_LENGTH)
  return `${first}${ELLIPSIS}${last}`
}

export const truncatePathWithTooltip = (
  path: string,
  length = 30
): React.ReactNode => {
  if (!path) return
  const trunactedPath = truncatePath(path, length)
  if (trunactedPath === path) return path

  return (
    <Tooltip title={path} placement="bottom">
      {trunactedPath}
    </Tooltip>
  )
}

export const truncate = (text: string, length = 30): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text

  return (
    <>
      {text.slice(0, length / 3)}...{text.slice(-TAIL_LENGTH)}
    </>
  )
}

export const truncateWithTooltip = (
  text: string,
  length = 30
): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text

  return (
    <Tooltip title={text} placement="bottom">
      {text.slice(0, length / 3)}...{text.slice(-TAIL_LENGTH)}
    </Tooltip>
  )
}

export const truncateStartWithTooltip = (
  text: string,
  length = 30
): React.ReactNode => {
  if (!text) return
  if (text.length <= length) return text
  return (
    <Tooltip title={text} placement="bottom">
      {text.slice(0, length / 3)}...
    </Tooltip>
  )
}
